import { render, staticRenderFns } from "./view-profile.vue?vue&type=template&id=f81d299a&scoped=true&"
import script from "./view-profile.vue?vue&type=script&lang=js&"
export * from "./view-profile.vue?vue&type=script&lang=js&"
import style0 from "./view-profile.vue?vue&type=style&index=0&id=f81d299a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81d299a",
  null
  
)

export default component.exports